import { CSSProperties } from 'react';

/**
 * Toast — bottom-center inverted pill for transient confirmations
 * ("Inquiry accepted", "Draft saved"). Render it conditionally; the parent
 * owns the message state and the auto-dismiss timer (see useToast).
 *
 * Long messages wrap inside the screen instead of running off the edge, and on
 * a phone it floats above the bottom bar / action bar rather than over it.
 */
export interface ToastProps {
  /** Message text. Renders nothing when empty. */
  message: string;
  style?: CSSProperties;
}

export function Toast({ message, style }: ToastProps) {
  if (!message) return null;
  return (
    <>
      <style>{'@keyframes sk-toast-in{from{opacity:0;transform:translate(-50%,8px)}to{opacity:1;transform:translate(-50%,0)}}.sk-toast{bottom:28px}@media (max-width:767px){.sk-toast{bottom:calc(96px + env(safe-area-inset-bottom,0px))}}'}</style>
      <div
        role="status"
        className="sk-toast"
        style={{
          position: 'fixed', left: '50%', zIndex: 70,
          width: 'max-content', maxWidth: 'calc(100vw - 32px)', textAlign: 'center',
          background: 'var(--text)', color: 'var(--bg)',
          fontFamily: 'var(--font-sans)', fontSize: 12.5, fontWeight: 500,
          borderRadius: 18, padding: '10px 20px', lineHeight: 1.4,
          boxShadow: '0 8px 28px rgba(0,0,0,.32)',
          animation: 'sk-toast-in .22s cubic-bezier(.16,.8,.3,1)',
          ...style,
        }}
      >
        {message}
      </div>
    </>
  );
}

export default Toast;
